import { usePageStore } from "#imports";

export default defineNuxtRouteMiddleware((to, from) => {
    const { pages } = storeToRefs(usePageStore());

    const getListPosition = (name: string) => {
        const found = pages.value.find(p => p.to === name);
        return found ? pages.value.indexOf(found) : -1;
    }

    const toIndex = getListPosition(to.fullPath.substring(to.fullPath.lastIndexOf('/')));
    const fromIndex = getListPosition(from.fullPath.substring(from.fullPath.lastIndexOf('/')));

    if (toIndex > fromIndex) {
        to.meta.pageTransition = { name: 'page-upward', mode: 'out-in' };
        from.meta.pageTransition = { name: 'page-upward', mode: 'out-in' }
    }
    else {
        to.meta.pageTransition = { name: 'page-downward', mode: 'out-in' };
        from.meta.pageTransition = { name: 'page-downward', mode: 'out-in' }
    }
    
    if (to?.name?.toString() === 'dev' || to?.name?.toString() === 'art' || to?.name?.toString() === 'contact') {
        abortNavigation();
        return navigateTo('/');
    }
});